import { Box, Grid, Stack, Typography } from '@mui/material';
import LogoImage from '../LogoImage';
import useGeneralHook from 'modules/common/hook/useGeneralHook';
import TextValue from './TextValue';

const PrintFormHeader = () => {
  const { appState } = useGeneralHook();
  const { currentLocation } = appState.authen;
  return (
    <Stack direction="row">
      <LogoImage
        src={currentLocation?.avatarId}
        className="logo"
        sx={{
          width: '135px',
          height: 'auto',
          objectFit: 'contain',
          marginRight: '86px',
        }}
      />
      <Box display={'flex'} flexDirection="column" gap={1}>
        <Typography variant="h6" style={{ textTransform: 'uppercase' }}>
          {currentLocation?.name}
        </Typography>
        <Grid container>
          <Grid xs={6}>
            <TextValue label={'medicalPrint.hotline'} value={currentLocation?.phone} labelWidth="60px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="clinics.website" value={currentLocation?.website} labelWidth="60px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="email" value={currentLocation?.email} labelWidth="60px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="clinics.address" value={currentLocation?.address} labelWidth="60px" />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export default PrintFormHeader;
